import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

import ContentModal from '../../common/ContentModal'

function HintModal(props) {
  const { title, markdown, onClose } = props
  return (
    <ContentModal id="instruction-panel-hint-modal" onClose={onClose}>
      <div style={{ padding: 40 }}>
        <h3>{title}</h3>
        <ReactMarkdown rehypePlugins={[rehypeRaw]} linkTarget="_blank">
          {markdown}
        </ReactMarkdown>
      </div>
    </ContentModal>
  )
}
HintModal.propTypes = {
  title: PropTypes.string.isRequired,
  markdown: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default HintModal
